import styled from 'styled-components'


export const StyledNotificationBanner = styled.div`
  display: flex;
  align-items: start;
  justify-content: flex-start;
  gap: ${({ theme }) => theme.rem(10)};
  padding: ${({ theme }) => theme.rem(16, 24)};
  border-radius: ${({ theme }) => theme.rem(12)};
  max-width: 358px;
  color: ${({ theme }) => theme.colors.typography.dark()};

  // The font somehow is not contrasted enough,
  // so we have to increase the weight.
  i, .notification-banner__label {
    font-weight: 600;
    line-height: 100%;
    font-size: ${({ theme }) => theme.rem(14)};
    color: inherit;
  }



  ${({ theme, variant }) => {
    switch (variant) {
      case 'success':
        return `
          background-color: ${theme.colors.status.success.default};
          color: ${theme.colors.typography.white};

          i { font-size: ${theme.rem(22)}; }
        `
      case 'warning':
        return `
          background-color: rgba(255, 194, 0, 0.1);
          color: ${theme.colors.status.warning.default};

          i { font-size: ${theme.rem(22)}; }
          `
      case 'error':
        return `
          background-color: ${theme.colors.status.error.highContrast};
          color: ${theme.colors.typography.white};

          i { font-size: ${theme.rem(22)}; }
        `
      case 'error_inverted':
        return `
          background-color: rgba(249, 247, 238, 1);
          color: ${theme.colors.status.error.highContrast};

          i { font-size: ${theme.rem(22)}; }
        `

      default:
      case 'info':
        return `
          background-color: ${theme.colors.grayscale.white};
          color: ${theme.colors.typography.dark()};

          i {
            border-radius: 50%;
            border: 2px solid currentColor;
            padding: 2px;
            font-size: ${theme.rem(13)};
          }
        `
    }
  }
};

  // prop can override the default font size
  i {
    font-size: ${({
    theme, iconSize
  }) => theme.rem(iconSize)};
  }
`
